export const getExhibitionRoutes = ({ urlPrefix = "" }) => {
  return [
    {
      title: "Overview",
      route: urlPrefix,
      fields: ["title", "subtitle", "description", "type"],
    },
    {
      title: "Space",
      route: urlPrefix + "/space",
      fields: ["gallerySpaceId"],
    },
    {
      title: "Uploads",
      route: urlPrefix + "/manage-files",
      fields: ["posterImageId", "screenshotIds"],
    },
    {
      title: "Art pieces",
      route: urlPrefix + "/manage-artpieces",
      fields: ["artPieces"],
    },
    {
      title: "Artifacts",
      route: urlPrefix + "/manage-artifacts",
    },
    {
      title: "Assets",
      route: urlPrefix + "/manage-assets",
    },
    // {
    //   title: "AR Targets",
    //   route: urlPrefix + "/manage-ar-targets",
    // },
  ]
}
